import User from '~/auth/User'
import { useAuthenticatedUser } from '~/auth/user.hooks'
import { useIsSparkOnboarded } from '~/hooks/useSparkBidder'

/** Pubstack users go by Spark onboarding, the toggle that provisions the Spark seats this dashboard reports on. */
export const isSparkDemandDashboardEnabled = (user: User, isSparkOnboarded: boolean): boolean => (user.isAdmin ? isSparkOnboarded : user.hasFeature('sparkDemandDashboard'))

export const useIsSparkDemandDashboardEnabled = (): boolean => isSparkDemandDashboardEnabled(useAuthenticatedUser(), useIsSparkOnboarded())
